import React from 'react';
import logo from '../assets/merchanerp-logo.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  LayoutDashboard, Users, ShoppingCart, Package,
  FileText, BarChart2, Settings, LogOut, Boxes
} from 'lucide-react';

const nav = [
  { label: 'SELL', items: [
    { icon: LayoutDashboard, name: 'Dashboard',     path: '/dashboard' },
    { icon: ShoppingCart,    name: 'Sales',         path: '/sales', perm: 'sales.view' },
    { icon: Users,           name: 'Contacts',      path: '/contacts', perm: 'contacts.view' },
    { icon: ShoppingCart,    name: 'Sales Returns', path: '/sales-returns', perm: 'sales.create_return' },
  ]},
  { label: 'CRM', items: [
    { icon: Boxes,           name: 'Accounts',      path: '/accounts',   perm: 'crm.view' },
    { icon: Boxes,           name: 'Enquiries',     path: '/enquiries',  perm: 'crm.view' },
    { icon: Boxes,           name: 'Follow-ups',    path: '/follow-ups', perm: 'crm.view' },
  ]},
  { label: 'REPAIRS', items: [
    { icon: Boxes,           name: 'Tickets',       path: '/service-tickets', perm: 'service.view' },
    { icon: Boxes,           name: 'Quick Quote',   path: '/quick-quote',     perm: 'service.view' },
  ]},
  { label: 'PURCHASE', items: [
    { icon: Package,         name: 'Purchase',      path: '/purchase', perm: 'purchase.view' },
    { icon: Package,         name: 'Returns',       path: '/purchase-returns', perm: 'purchase.create_return' },
  ]},
  { label: 'FINANCE', items: [
    { icon: FileText,        name: 'Journals',      path: '/journals', perm: 'journals.view' },
    { icon: FileText,        name: 'Chart of Accounts', path: '/coa', perm: 'coa.view' },
  ]},
  { label: 'STOCK', items: [
    { icon: Boxes,           name: 'Inventory',     path: '/inventory', perm: 'inventory.view' },
    { icon: Boxes,           name: 'Stock Transfer', path: '/stock-transfer', perm: 'stock_transfer.view' },
    { icon: Boxes,           name: 'Physical Count', path: '/physical-count', perm: 'stock_adjustment.view' },
    { icon: Boxes,           name: 'Stock Adjustment', path: '/stock-adjustment', perm: 'stock_adjustment.view' },
    { icon: Boxes,           name: 'Expiry Tracking', path: '/expiry-tracking', perm: 'expiry.manage' },
    { icon: Package,         name: 'Products',      path: '/products', perm: 'products.view' },
  ]},
  { label: 'REPORTS', items: [
    { icon: BarChart2,       name: 'Reports',       path: '/reports' },
  ]},
  { label: 'SYSTEM', items: [
    { icon: Settings,        name: 'Opening Balances', path: '/opening-balances', perm: 'opening_balances.manage' },
    { icon: Settings,        name: 'Opening Stock Lines', path: '/opening-stock-lines', perm: 'opening_balances.manage' },
    { icon: Settings,        name: 'Settings',      path: '/settings', perm: 'settings.manage' },
    { icon: Settings,        name: 'Payment Accounts',      path: '/settings/payment-accounts', perm: 'settings.manage' },
  ]},
];

const Sidebar: React.FC = () => {
  const { logout, user, hasPermission } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  return (
    <div className="sidebar">
      <div className="nav-logo"><img src={logo} alt="MerchanERP" /></div>
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--bdr)' }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--tx)' }}>{user?.name}</div>
        <div style={{ fontSize: 11, color: 'var(--tx3)' }}>{user?.email}</div>
      </div>

      {nav.map(group => {
        const visibleItems = group.items.filter((item: any) => !item.perm || hasPermission(item.perm));
        if (visibleItems.length === 0) return null;
        return (
        <div key={group.label}>
          <span className="nav-label">{group.label}</span>
          {visibleItems.map((item: any) => (
            <button
              key={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <item.icon size={14} />
              {item.name}
            </button>
          ))}
        </div>
        );
      })}

      <div style={{ marginTop: 'auto', width: '100%', borderTop: '1px solid var(--bdr)', padding: 8 }}>
        <button className="nav-item" onClick={logout} style={{ color: 'var(--red)' }}>
          <LogOut size={14} />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;









